<template>
  <div style="width: 100%">
    <keep-alive>
      <CambioDeHorarioSolicitudes v-if="menu.state == 'home'" />
      <CambioDeHorarioDetalle v-if="menu.state == 'detail'" />
    </keep-alive>
  </div>
</template>

<script>
import { default as CambioDeHorarioSolicitudes } from "./Cambio_De_Horario_Solicitudes.vue";
import { default as CambioDeHorarioDetalle } from "./Cambio_De_Horario_Detalle.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "report",
  components: {
    CambioDeHorarioSolicitudes,
    CambioDeHorarioDetalle,
  },
  data: () => ({
    loading: false,
  }),
  mounted() {},
  computed: {
    ...mapGetters("horarios", ["menu"]),
  },
  methods: {},
};
</script>

<style scoped>
.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #a4a0a0 !important;
}
</style>
